import React, { Component } from 'react';
import "./OfferExpired.scss";
import { setPageNameSiteSection, updateStandardDataLayerAttributes } from "../../analytics/adobe";
import { getOfferPreFilledData } from "../../selectors";
import { connect } from "react-redux";
import { offerExpiredInNormalDataLayer, offerExpiredInPendDataLayer } from "../../analytics/adobe/pendDataLayerValues";

class OfferExpired extends Component{
  componentDidMount() {
    const { pageName, siteSection }=(this.props.offerPreFilled.pendFlow?offerExpiredInPendDataLayer:offerExpiredInNormalDataLayer);
    updateStandardDataLayerAttributes(setPageNameSiteSection(pageName, siteSection), true);
  }
  render() {
    return (
      <div className="invalid-card">
        <div className="row">
          <div className="col max-auto text-center">
            <p className="info-icon"></p>
            <div className="">
              <h3 className="invalid-card-title">This Barclays Personal Loan application is no longer valid. </h3>
              <p>There is no action required at this time.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return { offerPreFilled: getOfferPreFilledData(state) };
};

export default connect(mapStateToProps)(OfferExpired);


